import React from 'react';

const PRAYER_ACCENT = { shacharit: '#1e3a5f', mincha: '#92400e', maariv: '#312e81' };

const formatCountdown = (secs) => {
  if (secs < 0) return 'עכשיו';
  if (secs < 60) return `${secs} שנ׳`;
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  if (m < 60) return `${m}:${String(s).padStart(2, '0')}`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return rm === 0 ? `${h}ש׳` : `${h}ש׳ ${rm}ד׳`;
};

const Minimal = ({ nextMinyan, secondsLeft, upcomingPrayers, allPrayerTimes, title, showTitle, bgColor, loading, error }) => {
  const rootStyle = { ...containerStyle, backgroundColor: bgColor || 'transparent' };

  if (loading) return (
    <div style={rootStyle}>
      <span style={{ color: '#94a3b8', fontSize: '0.9rem' }}>טוען...</span>
    </div>
  );

  if (error || !nextMinyan) return (
    <div style={rootStyle}>
      {showTitle && <span style={titleStyle}>{title}</span>}
      <span style={{ color: error ? '#c0392b' : '#94a3b8', fontSize: '0.9rem', flex: 1, textAlign: 'center' }}>
        {error || 'אין מנינים'}
      </span>
    </div>
  );

  const accent = nextMinyan.color || PRAYER_ACCENT[nextMinyan.prayer] || '#0369a1';
  const countdown = formatCountdown(secondsLeft);

  return (
    <div style={rootStyle}>
      {/* Color bar */}
      <div style={{ width: 3, height: '60%', borderRadius: 2, backgroundColor: accent, flexShrink: 0, alignSelf: 'center' }} />

      {showTitle && (
        <span style={{ ...titleStyle, marginRight: '0.25rem' }}>{title}</span>
      )}

      {/* Prayer name */}
      <span style={{
        fontSize: '1.05rem', fontWeight: 800, color: accent,
        whiteSpace: 'nowrap', flex: 1, marginRight: showTitle ? '0.5rem' : '0.75rem',
      }}>
        {nextMinyan.label}
      </span>

      {/* Time */}
      <span style={{
        fontSize: '1.3rem', fontWeight: 900, color: '#0f172a',
        fontVariantNumeric: 'tabular-nums', direction: 'ltr',
        whiteSpace: 'nowrap', letterSpacing: '-0.02em',
      }}>
        {nextMinyan.time}
      </span>

      {/* Countdown pill */}
      <span style={{
        fontSize: '0.7rem', fontWeight: 700, color: accent,
        backgroundColor: accent + '15',
        border: `1px solid ${accent}30`,
        borderRadius: 100,
        padding: '0.15rem 0.6rem',
        whiteSpace: 'nowrap', flexShrink: 0,
      }}>
        {countdown}
      </span>
    </div>
  );
};

const containerStyle = {
  width: '100%', height: '100%',
  display: 'flex', flexDirection: 'row', alignItems: 'center',
  direction: 'rtl', fontFamily: 'inherit', boxSizing: 'border-box',
  padding: '0 0.75rem', gap: '0.5rem',
};

const titleStyle = {
  fontSize: '0.75rem', fontWeight: 600, color: '#94a3b8',
  whiteSpace: 'nowrap', flexShrink: 0,
};

export default Minimal;
